import { HTTP } from '@community_dev/requests'
import { Api } from '@community_dev/types'
import { VoiceAction } from '@community_dev/types/lib/api/InfobipVoice'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'
import { route } from 'utils/router'
import { toTransformExceptFn } from 'utils/transformExcept'

export type VoiceSetup = CamelCasedPropertiesDeep<Api.InfobipVoice.VoiceSetup>

export type VoiceOptions = {
  actions: Partial<Record<VoiceAction, string>>
}

export type VoiceStatus = {
  voiceSetups: Record<string, VoiceSetup>
  options: VoiceOptions
}

export type AssignVoiceSetupResponse = CamelCasedPropertiesDeep<Api.InfobipVoice.AssignVoiceSetupResponse>

// `options.actions` is keyed by VoiceAction (UPPERCASE_SNAKE) on the wire, but the default response transformer would camelCase those keys and break alignment with the action values returned in voice_setups[].action. Opt this subtree out so the keys stay matched everywhere.
const transformVoiceStatusResponse = toTransformExceptFn('options.actions')

export const getVoiceStatus = ({ clientId }: { clientId: string }): Promise<VoiceStatus> => {
  return request(route(ENDPOINTS.INFOBIP_VOICE.STATUS, { clientId }), {
    method: HTTP.GET,
    transformer: transformVoiceStatusResponse,
  })
}

export const postDefaultIvr = ({
  clientId,
  phoneNumber,
}: {
  clientId: string
  phoneNumber: string
}): Promise<AssignVoiceSetupResponse> => {
  return request(route(ENDPOINTS.INFOBIP_VOICE.ASSIGN_DEFAULT_IVR, { clientId, phoneNumber }), {
    method: HTTP.POST,
  })
}

export const postVoiceAction = ({
  clientId,
  phoneNumber,
  action,
  actionPayload,
  description,
}: {
  clientId: string
  phoneNumber: string
  action: VoiceAction
  actionPayload: string
  description: string
}): Promise<AssignVoiceSetupResponse> => {
  return request(route(ENDPOINTS.INFOBIP_VOICE.ASSIGN_VOICE_ACTION, { clientId, phoneNumber }), {
    method: HTTP.POST,
    body: {
      action,
      action_payload: actionPayload,
      description,
    },
  })
}
